import {
  useEffect,
} from 'react';
import { useLocation } from 'react-router';
import { env } from 'constants';
import usePersistedState from './usePersistedState';

function useHomePath() {
  const [home, setHome] = usePersistedState('#', 'use-home-path/home');
  const { pathname } = useLocation();

  useEffect(() => {
    if (!env.IS_MARKETPLACE && !env.IS_CATERING) {
      setHome('/feed');
      return;
    }
    if (env.IS_CATERING && !env.IS_MARKETPLACE) {
      setHome('/');
      return;
    }

    // TODO: strictly match the route
    if (['/place/'].some((path) => pathname?.includes(path))) {
      setHome(pathname);
    }
  }, [home, pathname, setHome]);

  return home;
}

export default useHomePath;
